import React, { useMemo, useState, useEffect } from 'react';
import { Row, Col, Form } from 'reactstrap';
import {
    TextArea,
    SelectDropdown,
    CustomButton,
} from '../../Components/Common/FormInputs';
import useFormvalidation from '../../hooks/validations/useFormvalidation';
import validate from '../../hooks/validations/FormValidationRules';
import { OrderCommentForm } from '../../hooks/validations/FormValidationRulesNew';
import useOrder from '../../hooks/useOrder';
import { useSelector } from 'react-redux';
import ErrorBoundary from "../../Components/Common/ErrorBoundary";
import { getUserApiBySearch } from '../../services/Apis';
const Commments = ({ orderid, toggle }) => {
    const { postcomments } = useOrder();
    const [userData, setuserData] = useState([]);
    const [UserDropdownData, setUserDropdownData] = useState([]);
    const masterdata = useSelector((state) => state.globalslice.masterdata || []);
    const ordercomments = useMemo(() => (
        (masterdata || [])
            .filter(ele => ele.list_type === 'order_comments')
            .map(item => ({ label: item.list_lable, value: item.list_lable }))
    ), [masterdata]);

    const fetchApi = async () => {
        const response = await getUserApiBySearch("");
        setuserData(response);
    }
    const handleUserSearch = async (value) => {
        const response = await getUserApiBySearch(value);
        setuserData(response);
    };

    useEffect(() => {
        if (ordercomments.length > 0) {
            setValues(prev => ({
                ...prev,
                Message: ordercomments[0].value   // set first index as default
            }));
        }
    }, [ordercomments]);


    useEffect(() => {
        fetchApi();
    }, []);


    useEffect(() => {
        if (userData?.data) {
            setUserDropdownData([...userData?.data?.result?.map((item) => ({
                label: item.firstname,
                value: item.id,
            })) || []])
        }
    }, [userData])

    const formValues = {
        Notes: '',
        Message: '',
        orderid: orderid,
        assign_to: ''
    };

    const handleNext = async () => {
        const { Notes, Message, assign_to } = values;
        {
            toggle != undefined &&
                toggle()
        }
        const payload = {
            comment: Notes,
            status: Message,
            assign_to: assign_to,
            orderid: orderid,
        };


        postcomments.mutate(payload, {
            onSuccess: () => {
                // Reset form on success

                setUserDropdownData([...userData?.data?.result?.map((item) => ({
                    label: item.firstname,
                    value: item.id,
                })) || []])

                setValues(prev => ({
                    ...prev,
                    Notes: '',
                    assign_to: '',
                    orderid
                }));
            },
        });
    };

    const {
        handleChange,
        handleSubmit,
        errors,
        values,
        setValues,
        handleToggleChange,
    } = useFormvalidation(handleNext, OrderCommentForm, formValues);

    return (

        <ErrorBoundary fallback={<div>Oops! Something went wrong .</div>}>
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col lg={12}>
                        <TextArea
                            name="Notes"
                            placeholder="Enter Notes"
                            label="Notes"
                            onChange={handleChange}
                            isrequired
                            value={values.Notes || ''}
                            error_msg={errors.Notes}

                        />
                    </Col>

                    <Col lg={12}>
                        <SelectDropdown
                            label="Status Message"
                            options_data={ordercomments}
                            name="Message"
                            isrequired
                            isMultiple={false}
                            setValues={setValues}
                            values={values}
                            value={values.Message}
                            error_msg={errors.Message}

                        />
                    </Col>
                    <Col lg={12}>
                        <SelectDropdown
                            label="Assign To"
                            options_data={UserDropdownData}
                            name={'assign_to'}
                            setValues={setValues}
                            values={values}
                            isrequired
                            value={values.assign_to}
                            isMultiple={true}
                            onSearch={handleUserSearch}
                            error_msg={errors.assign_to}
                        />
                    </Col>

                    <Col lg={6} className="d-flex align-items-end">
                        <CustomButton
                            handleSubmit={handleSubmit}
                            label={postcomments.isLoading ? 'Posting...' : 'Post'}
                            disabled={postcomments.isLoading}
                            loading={postcomments?.isPending}
                        />
                    </Col>
                </Row>
            </Form>
        </ErrorBoundary>

    );
};

export default React.memo(Commments);
